import PhoneNumberInput from "../../../components/PhoneNumberInput";
import { useField } from "../hooks/useField";
import { useFormFieldContext } from "./FormField";

interface PhoneNumberFormFieldProps {}

export function PhoneNumberFormField({}: PhoneNumberFormFieldProps) {
  const {
    name,
    disabled,
    readOnly,
    required,
    defaultValue,
    validation,
    customValidation,
    descriptionId,
    errorMessageId,
    shouldUnregister,
  } = useFormFieldContext();

  const { ref, value, onChange, onBlur, error } = useField({
    name,
    defaultValue,
    validation,
    customValidation,
    shouldUnregister,
  });

  return (
    <PhoneNumberInput
      inputRef={ref}
      id={name}
      name={name}
      value={value}
      onChange={(value) => onChange(value ? `+${value}` : "")}
      onBlur={onBlur}
      error={!!error}
      readOnly={readOnly}
      disabled={disabled}
      aria-required={required}
      aria-describedby={
        !error ? `${descriptionId}` : `${descriptionId} ${errorMessageId}`
      }
      aria-invalid={!!error}
    />
  );
}
